import { useRouter } from 'next/router'
import Account from 'components/account/account'
import AccountSettings from 'components/account-settings/account-settings'
import useApi from 'utils/api'
import useAppState from 'utils/state'
import { getRoute } from 'utils/helpers'

export default function Page() {
    const router = useRouter()
    const api = useApi()
    const { showLoader } = useAppState()

    const handleSubmit = async data => {
        showLoader(true)
        const response = await api.postWithToast('account', data)
        showLoader(false)

        if (response.status === 200 && !data.verified) {
            router.push(getRoute('account-contract'))
        }
    }

    return (
        <Account title="Nustatymai">
            <AccountSettings endpoint="account" onSubmit={handleSubmit} />
        </Account>
    )
}
